import $ = require('jquery');

/**
 * Matrix module
 */
    import AppRegistry from "diy/AppRegistry";
    import { OverlayStatusMap, moduleOverlayShow, moduleOverlayHide, moduleOverlayChangeStatus }
        from 'diy/overlay/index';
    import Modul, {InsertDestinationParams} from './Modul';
    let siteadminApi = require<any>('diy/site-admin/main/api');

    function getStore() {
        return AppRegistry.getStoreProvider().getStore();
    }

    export default class ModulMatrix extends Modul {
        /**
         * Instead of opening a config view, we just freeze the overlay
         * so we can edit the modules in the matrix
         */
        open() {
            let self = this;
            let moduleId = this.moduleId;

            // first put in active state to disable other modules overlay while animating
            getStore().dispatch(moduleOverlayShow({moduleId, status: OverlayStatusMap.ACTIVE}));

            this.getContentContainer().find('.matrix-module-configuration').slideDown(function() {
                self.hideOverlay();
                self.freezeOverlay(true);
                getStore().dispatch(moduleOverlayHide({moduleId}));
            });

            // matrix module will add content on server side, so it's actually never new
            //  and it does not have a cancel action
            this.setIsNew(false);

            this.getContentContainer().find('input.checkbox').diy_checkbox().click(function() {
                let flag = $(this).is(':checked');
                siteadminApi.toggleSidebar(!flag);
                self.setFullwidth(flag);
            });

            try {
                // initialize help link
                cms.help.GuidedAssistant._instance
                    ._initSiteAdminButtonByClass(cms.help.GuidedAssistant.options.modulesLinkClass);
            } catch (e) {
                // do nothing
            }
        }
        /**
         * Returnes whether there is an opened module inside the matrix.
         * If not, returns null
         */
        getChildModuleInEditMode() {
            let childrenInEdit = this.getChildModules().filter(m => m.getIsInEditMode());
            return childrenInEdit.length ? childrenInEdit[0] : null;
        }
        /**
         * Instead of closing the config view, we just unfreeze the overlay
         * so we can edit the matrix module itself
         */
        close() {
            let self = this;
            let childModuleInEditMode: Modul;

            /* added in try-catch just for the moment */
            try {
                /* if there's any module currently editing inside the matrix,
                we close it immidiately */
                childModuleInEditMode = this.getChildModuleInEditMode();
                if (childModuleInEditMode) {
                    childModuleInEditMode.close();
                }
            } catch (e) {
                // do nothing
            }

            getStore().dispatch(moduleOverlayShow({moduleId: this.moduleId, status: OverlayStatusMap.ACTIVE}));

            this.getContentContainer().find('.matrix-module-configuration').slideUp(function() {
                self.freezeOverlay(false);
                self.showOverlay();
                getStore().dispatch(moduleOverlayChangeStatus({status: OverlayStatusMap.HOVER}));
            });
        }
        /**
         * Remove method for matrix module first removes the elements inside it
         * and then removes itself. This removal is only DOM, the ajax delete
         * request is not performed from here
         */
        remove() {
            this.getChildModules().forEach(m => {
                let moduleId = m.moduleId;
                m.remove();
                Modul.deleteInstance(moduleId);
            });

            super.remove.apply(this, arguments);
        }
        showBusyMask() {
            this.getModuleElement().find('.matrix-module-configuration-busy').show();
        }
        hideBusyMask() {
            this.getModuleElement().find('.matrix-module-configuration-busy').hide();
        }
        /**
         * add a local module of a certain type into a certain matrix in the current page
         * @param type
         * @param matrixId
         */
        addM(type: string, matrixId: number) {
            // show busy mask to prevent additional clicks - #DHDIY-20542
            this.showBusyMask();

            let destinationParams: InsertDestinationParams = {
                matrixId: matrixId,
                afterChildId: null,
                pageId: 0 // same page
            };

            let moduleObj = {
                getInsertParams: function() {
                    return {
                        moduleName: type
                    };
                },
                getInsertPlaceholder: function() {
                    return $('<div class="diye-new-module-placeholder"></div>');
                }
            };

            Modul.insert('add', moduleObj, destinationParams);
        }

        toggleStyle() {
            if (this.modul.find("label.switch-label.selected").attr('data-attr') === 'teaser') {
                this.switchStyle('default');
            } else {
                this.switchStyle('teaser');
            }
        }

        getGrid() {
            return this.modul.find('div.diyfeModGridGroup');
        }

        getFieldIsFullwidth() {
            return $('#formular_' + this.moduleId).find('input[type=hidden][name=isFullwidth]');
        }

        isTeaser() {
            return this.getGrid().hasClass('diyfeModGridStyleTeaser');
        }

        setTeaser(flag: boolean) {
            if (flag) {
                if (!this.isTeaser()) {
                    this.getGrid().addClass('diyfeModGridStyleTeaser');
                }
            } else {
                this.getGrid().removeClass('diyfeModGridStyleTeaser');
            }
        }

        setFullwidth(flag: boolean) {
            this.getFieldIsFullwidth().val(flag ? 1 : 0);
            this.modul.toggleClass('diyfeLiveArea', !flag);
            $('#module-overlay-group-' + this.moduleId)
                .find('.module-deletebar-wrapper').toggleClass('fullwidth', flag);
            $('#module-overlay-group-' + this.moduleId)
                .find('.module-movebar').toggleClass('fullwidth', flag);
        }

        /**
         * Switches the style to new class (i.e teaser)
         * @param type
         */
        switchStyle(styleType: string) {
            let teaserObject = this.modul.find("div.diyfeModGridGroup");
            let hiddenInput = $("#formular_" + this.moduleId).find("input[type='hidden'][name='cssClasses']");
            let sliderObject = this.modul.find(".matrix-module-configuration .th-btn-toggle");

            if (styleType === "teaser") {
                if (!teaserObject.hasClass("diyfeModGridStyleTeaser")) {
                    teaserObject.addClass("diyfeModGridStyleTeaser");
                }

                if (!$("#switch-label-teaser-" + this.moduleId).hasClass("selected")) {
                    $("#switch-label-teaser-" + this.moduleId).addClass("selected");
                }
                $("#switch-label-default-" + this.moduleId).removeClass("selected");

                sliderObject.removeClass("diy-btn-selected");
            } else {
                if (!sliderObject.hasClass("diy-btn-selected")) {
                    sliderObject.addClass("diy-btn-selected");
                }

                if (!$("#switch-label-default-" + this.moduleId).hasClass("selected")) {
                    $("#switch-label-default-" + this.moduleId).addClass("selected");
                }
                $("#switch-label-teaser-" + this.moduleId).removeClass("selected");
                teaserObject.removeClass("diyfeModGridStyleTeaser");

            }
            hiddenInput.val(teaserObject.attr("class"));
        }

        save() {
            return super.save.apply(this, arguments);
        }
    }



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulMatrix.ts
 **/